/**
 *   Import
 *   - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'

import '../styles/Footer.css'

export default class DashboardFooter extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }

    handleClick = () => {
        this.props.goTo('/quote/new/step00')
    }

    render() {
        return (
            <div className="dashboard-footer">
                <div className="dashboard-footer dashboard-footer__brick" >
                    <Button type="submit" onClick={this.handleClick}>Get a quote</Button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Dashboard/components/Footer.tsx